module.exports = __webpack_public_path__ + "i18n/tr.a19c86968e07c8475155fb583475c41c.json";